import {ProposalResource} from "../../types/Proposal";
import {ModalWindow} from "../modal/ModalWindow";
import React, {useState} from "react";
import ArrowBackIosNewOutlinedIcon from '@mui/icons-material/ArrowBackIosNewOutlined';
import ArrowForwardIosOutlinedIcon from '@mui/icons-material/ArrowForwardIosOutlined';
import { adaptImageData } from "../../utils/IngestorConverters";

const bigImageStyle = {
    maxHeight: '100%',
    maxWidth: '100%'
}

export function ImageViewer({resources, onClose, index}:{onClose:() => void, index:number, resources:ProposalResource[]}) {
    const [showImage, setShowImage] = useState(index);

    return <ModalWindow onClose={() => onClose()}>
        <div style={{position: 'relative'}}>
            {/* left half overlay: previous */}
            <div
                className={"image-viewer-overlay image-viewer-overlay-left pointer"}
                aria-label={"previous image"}
                onClick={() => {
                    setShowImage(showImage === 0 ? resources.length - 1 : showImage - 1);
                }}
            >
                <span className={"image-viewer-arrow"}>
                    <ArrowBackIosNewOutlinedIcon fontSize={"small"}/>
                </span>
            </div>

            <img alt={"source"} src={adaptImageData(resources[showImage].source, 'content', resources[showImage].content)} style={bigImageStyle}/>

            {/* right half overlay: next */}
            <div
                className={"image-viewer-overlay image-viewer-overlay-right pointer"}
                aria-label={"next image"}
                onClick={() => {
                    setShowImage(showImage === resources.length - 1 ? 0 : showImage + 1);
                }}
            >
                <span className={"image-viewer-arrow"}>
                    <ArrowForwardIosOutlinedIcon fontSize={"small"}/>
                </span>
            </div>
        </div>
    </ModalWindow>
}